import { Skeleton } from '@/components/atoms/Skeleton';
import { theme } from '@/styles/theme';

export default function ListagemTitulosFallback({
  $paddingLeft = 0,
}: {
  $paddingLeft?: number;
}) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing[6],
      }}
    >
      <Skeleton
        style={{
          height: 32,
          width: '40vw',
          marginLeft: $paddingLeft,
        }}
      />
      <div
        style={{
          display: 'grid',
          gridAutoFlow: 'column',
          gridAutoColumns: theme.tamanhoCartaz.width['medio'],
          gap: theme.spacing[5],
          alignItems: 'stretch',
          marginLeft: $paddingLeft,
          overflow: 'hidden',
        }}
      >
        {Array.from({ length: 8 }).map((item, index) => (
          <Skeleton
            key={`${item}_${index}`}
            style={{
              height: 307,
              width: theme.tamanhoCartaz.width['medio'],
            }}
          />
        ))}
      </div>
    </div>
  );
}
